import { z } from 'zod';
import { parsePemAndGetValidityPeriod } from '@lucidlink/ts-crypto/crypto';
import { createErrorHandler } from './helpers/error-handler';
export const pemValidator = ({ requiredError, invalidFormatError, expiredError, maxLength, }) => {
    let validator = z.string({
        error: createErrorHandler(requiredError),
    });
    if (maxLength) {
        validator = validator.max(maxLength.max, maxLength.error);
    }
    return validator.superRefine((val, ctx) => {
        try {
            const validity = parsePemAndGetValidityPeriod(val);
            if (validity.notAfter.getTime() < Date.now()) {
                ctx.addIssue({
                    code: 'custom',
                    message: expiredError,
                    fatal: true,
                });
            }
        }
        catch (_) {
            ctx.addIssue({
                code: 'custom',
                message: invalidFormatError,
            });
        }
    });
};
